import { BookingGuest } from "@/types/booking";

export type CheckoutGuestFields =
  | { guestPosition: number; guestName?: string }
  | Record<string, never>;

/**
 * Guest fields for appointment preview and create.
 * Position 1 is the booking client. Sending it alone stores a guest row and
 * makes a client-only booking look like a group booking.
 */
export function checkoutGuestFields(
  guestId: string | null | undefined,
  guests: BookingGuest[]
): CheckoutGuestFields {
  const hasAdditionalGuest = guests.some((guest) => guest.position > 1);
  if (!hasAdditionalGuest || !guestId) return {};

  const guest = guests.find((item) => item.id === guestId);
  if (!guest) return {};

  const name = guest.name?.trim();
  return {
    guestPosition: guest.position,
    ...(name ? { guestName: name } : {}),
  };
}
